import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import SiteHeader from "../components/SiteHeader";
import SitePanel from "../components/SitePanel";
import SiteFooter from "../components/SiteFooter";
import ButtonToTop from "../components/ButtonToTop";
import FooterCookie from "../components/FooterCookie";

const MainLayout = () => {
  const { pathname } = useLocation();

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    scrollToTop();
  }, [pathname]);

  return (
    <div>
      <SiteHeader />
      <SitePanel />
      <Outlet />
      <FooterCookie />
      <SiteFooter />
      <ButtonToTop />
    </div>
  );
};

export default MainLayout;
